import React, { useContext, useMemo } from "react"
import {
  Modal,
} from "../ui_new"
import { CheckCircle, Close } from "../../assets/icons"
import { Cancel } from "@mui/icons-material"
import { VALIDATION_STATUS } from "../../constants"
import contentSign from "../../constants/validationWarningContentSign"
import contentLRE from "../../constants/validationWarningContentLRE"
import contentShare from "../../constants/validationWarningContentShare"
import { UserContext } from "../../context"

const ValidationWarningModal = ({
  action = 'share', // 'share' | 'sign' | 'lre'
  onClose,
  status,
  validation,
  onConfirm = () => { throw new Error('onConfirm function not provided') },
}) => {

  const { user } = useContext(UserContext)
  
  const handleCancel = () => {
    onClose()
  }

  const handleConfirm = () => {
    onConfirm()
  }

  const content = useMemo(() => {
    if(status.includes(VALIDATION_STATUS.SIGNATURE_NOT_AVAILABLE)) {
      return {
        title: 'Indisponible',
        text: 'La signature électronique n\'est pas disponible sur ce modèle de document en raison de dispositions législatives interdisant de recourir à la signature électronique sur ce type de document juridique.',
        cancelLabel: 'Fermer',
        confirmLabel: '',
      }
    }
    const isValidator = user.validation_access === 'manager'
    let sourceContent = {}
    if (action === 'sign') {
      sourceContent = contentSign
    } else if (action === 'lre') {
      sourceContent = contentLRE
    } else {
      sourceContent = contentShare
    }
    const validatorKey = isValidator ? 'validator' : 'nonValidator'
    const requiredKey = status.includes(VALIDATION_STATUS.VALIDATION_REQUIRED) ? 'required' : 'optional'
    const statusKey = status.includes(VALIDATION_STATUS.VALIDATED) ? 'validated' :
      status.includes(VALIDATION_STATUS.NOT_VALIDATED) && validation ? 'notValidatedTask' :
      status.includes(VALIDATION_STATUS.NOT_VALIDATED) ? 'notValidatedNoTask' : ''
    const completionKey = status.includes(VALIDATION_STATUS.NOT_COMPLETE) ? 'notCompleted' : 'completed'
    
    console.log("validation warning content keys:", {status, validatorKey, requiredKey, statusKey, completionKey, sourceContent})
    
    return sourceContent?.[validatorKey]?.[requiredKey]?.[statusKey]?.[completionKey]
  }, [action, user, status, validation])

  const title = useMemo(() => {
    return content?.title || 'Action invalide'    
  }, [content])

  const descriptionText = useMemo(() => {
    return content?.text || ''
  }, [content])

  const questionText = useMemo(() => {
    return content?.question || ''
  }, [content])

  const cancelLabel = useMemo(() => {
    return content?.cancelLabel || 'Fermer'
  }, [content])

  const confirmLabel = useMemo(() => {
    return content?.confirmLabel || ''
  }, [content])

  const confirmIcon = <CheckCircle />

  return (
    <Modal onClose={onClose} className="modal-v2 modal-v2--medium">
        <div className="modal-v2__heading modal-v2__heading--light modal-v2__heading--small">
          <h2>{title}</h2>
          <div className="buttons-row">
            <button
              className="btn btn--small btn--light btn--border-primary btn--border-radius-sm btn--square"
              onClick={onClose}
            >
              <Close />
            </button>
          </div>
        </div>
        <div className="document-share__body">
          <div>
            {descriptionText && <p className="share-warning--text">{descriptionText}</p>}
            {questionText && <p className="share-warning--question">{questionText}</p>}
            {/* {hintText && <p className="share-warning--hint">{hintText}</p>} */}
          </div>
          <div className="modal-v2__buttons-footer">
            {cancelLabel && (
              <button
                className="modal-v2__btn modal-v2__btn-danger"
                onClick={handleCancel}
              >
                <Cancel fontSize="small" />
                {cancelLabel}
              </button>
            )}
            {confirmLabel && (
              <button
                className="modal-v2__btn modal-v2__btn-success"
                onClick={handleConfirm}
              >
                {confirmIcon && confirmIcon}
                {confirmLabel}
              </button>
            )}
          </div>
        </div>
    </Modal>
  )
}

export default ValidationWarningModal
